const CLIENT_TOKEN_STORAGE_KEY = "payways_token";

export const getClientToken = () => {
  return localStorage.getItem(CLIENT_TOKEN_STORAGE_KEY);
};

export const saveClientToken = (token) => {
  localStorage.setItem(CLIENT_TOKEN_STORAGE_KEY, token);
};

export const removeClientToken = () => {
  localStorage.removeItem(CLIENT_TOKEN_STORAGE_KEY);
};
